var _circle, _path, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFastMatching(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#ECF9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 36.2152C15 32.4078 18.0865 29.3213 21.8939 29.3213H35.0292C38.8366 29.3213 41.9231 32.4078 41.9231 36.2152V39.788C41.9231 40.7398 41.1514 41.5115 40.1996 41.5115H16.7235C15.7716 41.5115 15 40.7398 15 39.788V36.2152Z",
    fill: "#4FC0CF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7253,
    cy: 18.8152,
    r: 7.81517,
    fill: "#4FC0CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9199 26.1855C48.5715 26.1857 49.1704 26.501 49.5439 27.0127L49.6152 27.1172L49.6797 27.2256C49.9841 27.7749 50.0186 28.4377 49.7676 29.0186L48.6338 31.6475H50.3828C51.136 31.6476 51.8116 32.0676 52.1572 32.7148H52.1562C52.5004 33.3585 52.4729 34.1378 52.0859 34.7549V34.7559L44.8965 46.1914L44.8955 46.1904C44.5206 46.7869 43.8737 47.1338 43.1934 47.1338C42.9196 47.1337 42.6441 47.0774 42.3848 46.9629C41.4732 46.5607 41.0088 45.5659 41.2373 44.627L42.5264 39.3242H39.7451C39.067 39.3242 38.444 38.982 38.0742 38.4297C37.7083 37.883 37.6302 37.1924 37.8623 36.5781V36.5771L41.3027 27.4902V27.4893C41.5946 26.7202 42.3328 26.1855 43.1855 26.1855H47.9199Z",
    fill: "#7ED957",
    stroke: "#ECF9FE",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastMatching);
export default __webpack_public_path__ + "static/media/FastMatching.7e7323b5286048be73ecdabfe7298c2e.svg";
export { ForwardRef as ReactComponent };